import { Injectable } from '@angular/core';
import { FastSearchLayout, InlineSearchLayoutComponent } from 'gung-list';
import {
  ProductInlineSearchListConfigService,
  ProductService,
  AuthService,
  PriceService,
  Product,
  ProductFastsearchDetailComponent,
  BaseViewConfigService
} from 'gung-standard';
import { TyloInlineSearchCardComponent } from '../components/tylo-inline-search-card/tylo-inline-search-card.component';

@Injectable({
  providedIn: 'root'
})
export class TyloInlineSearchListConfigService extends ProductInlineSearchListConfigService {
  skuLevel = true;
  constructor(
    protected productService: ProductService,
    protected authService: AuthService,
    protected priceService: PriceService,
    protected baseViewConfigService: BaseViewConfigService
  ) {
    super(productService, authService, priceService, baseViewConfigService);
  }

  getLayout(): FastSearchLayout<Product> {
    return {
      getLayout: () => InlineSearchLayoutComponent,
      getListItemComponent: () => TyloInlineSearchCardComponent,
      getDetailItemComponent: () => ProductFastsearchDetailComponent
    };
  }
}